import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../hooks/context";
import {
  AuthInput,
  AuthPasswordInput,
} from "../../components/form/input/AuthInput";
import AlertError from "../../components/ui/error/AlertError";
import BlockButton from "../../components/button/BlockButton";

const {
  REACT_APP_LOGIN_CLIENT_EMAIL: clientEmail,
  REACT_APP_LOGIN_CLIENT_PASSWORD: clientPassword,
  REACT_APP_LOGIN_PAYMENT_EMAIL: paymentEmail,
  REACT_APP_LOGIN_PAYMENT_PASSWORD: paymentPassword,
  REACT_APP_LOGIN_AUTHOR_EMAIL: authorEmail,
  REACT_APP_LOGIN_AUTHOR_PASSWORD: authorPassword,
} = process.env;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, userLogin } = useGlobalContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const { isLoggedIn, email: userEmail } = user || {};

  let { from } = location.state || { from: { pathname: "/" } };

  useEffect(() => {
    if (isLoggedIn && userEmail === paymentEmail) {
      navigate("/payment/pair");
    } else if (isLoggedIn && userEmail === authorEmail) {
      navigate("/authority/payment");
    } else if (isLoggedIn) {
      navigate("/");
    }
  }, [isLoggedIn, navigate, userEmail]);

  const submitHandler = (e) => {
    e.preventDefault();
    const isClient = email === clientEmail && password === clientPassword;
    const isPayment = email === paymentEmail && password === paymentPassword;
    const isAuthor = email === authorEmail && password === authorPassword;
    if (isClient) {
      reset();
      userLogin({ email, password });
      navigate(from);
    } else if (isPayment) {
      reset();
      userLogin({ email, password });
      navigate("/payment/pair");
    } else if (isAuthor) {
      reset();
      userLogin({ email, password });
      navigate("/authority/payment");
    } else {
      setMessage("Invalid Email and Password!");
    }
  };

  const reset = () => {
    setEmail("");
    setPassword("");
    setMessage("");
  };

  return (
    <section className="grid h-screen md:grid-cols-2">
      <div className="md:col-span-1 py-12 px-10 xl:px-32">
        {/* <h1 className="text-2xl text-gray-700 uppercase font-semibold">Logo</h1> */}

        <div className="grid items-center w-full h-full">
          <img
            src="/logo/donation-logo.png"
            alt="Fund a chairity"
            className="w-52 h-16"
          />
          <form
            className="-mt-32 lg:px-10 xl:px-12 2xl:px-32"
            onSubmit={submitHandler}
          >
            <h2 className="mb-8 text-xl text-gray-500 font-semibold">
              Login Here
            </h2>
            <AuthInput
              name="email"
              type="email"
              label="Email"
              required={true}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <AuthPasswordInput
              name="password"
              label="Password"
              required={true}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <BlockButton type="submit" text="Login" />
            {message && <AlertError message={message} />}
          </form>
        </div>
      </div>
      <div className="hidden md:block col-span-1 min-h-screen w-full bg-[url('https://i.ibb.co/VqftdWS/6068656.jpg')] bg-no-repeat bg-cover"></div>
    </section>
  );
};

export default Login;
